import { ITransferMajorsDatasource } from './../../datasources/transfer_majors_datasource';
import { Major } from './../../builders/major_builder';
import { ICommand } from './../../../../vendor/core-ts-types/dist/main';
import { SelectionListServant } from './../../../global/servants/selection_list_servant';

export class MajorCheckboxController {
  private major: Major;
  private isAccordionOpen: boolean;
  static flags: {
    hasRequestedChange: boolean;
  } = {
    hasRequestedChange: false
  };

  constructor(
    private $element: ng.IAugmentedJQuery,
    private ngSelectionListServant: SelectionListServant,
    private ngTransferMajorsDatasource: ITransferMajorsDatasource,
    private selectTransferMajorCommand: ICommand,
    private deselectTransferMajorCommand: ICommand
  ) {
    $element.addClass('width-full paz');
  }

  toggleMajorSelection($event: CustomEvent): void {
    const isCheckboxSelected: boolean = $event.detail.value;

    if (this.major.isSelected === isCheckboxSelected) {
      return;
    }

    if (MajorCheckboxController.flags.hasRequestedChange) {
      return;
    }

    MajorCheckboxController.flags.hasRequestedChange = true;

    const requestChangeCommand: ICommand =
      !this.hasAllMajorsSelected() && isCheckboxSelected
        ? this.selectTransferMajorCommand
        : this.deselectTransferMajorCommand;

    requestChangeCommand(this.major).finally((): void => {
      MajorCheckboxController.flags.hasRequestedChange = false;
    });
  }

  isDisabled(): boolean {
    return this.hasAllMajorsSelected() && !this.major.isSelected;
  }

  hasAllMajorsSelected(): boolean {
    return this.ngSelectionListServant.isFull(this.ngTransferMajorsDatasource.model.majorsSelection);
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngMajorCheckboxController', MajorCheckboxController)
  .component('majorCheckbox', {
    controller: 'ngMajorCheckboxController',
    templateUrl: 'lib/transfer/components/major_checkbox/major_checkbox.html',
    controllerAs: '$ctrl',
    bindings: {
      major: '<',
      isAccordionOpen: '<'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/major_checkbox/major_checkbox.ts